// features.js — "Follow one visit" scrollytelling act (ported from website2-features.jsx).
// Four scenes built from the real product designs: the merchant landing page, automated
// reminders, agreements, and the Square checkout ticket + terminal. Sticky stage on
// desktop; the design's stacked mobile fallback is intentionally skipped.
import React from 'react'
import { N2Ic, NIc, N2Paw } from './icons'
import { N2Btn, N2Cursor, N2Sticker, N2Toast, N2Window, useN2Phases } from './shell'
import { trackGetStartedClick } from './track'
import { N2Scallop, N2SectionHead } from './sections'
import namiLogo from '../../assets/nami-logo.png'

/* ── scene 1 · the merchant landing page ── */
export const N2F_LP_THEMES = [
	{ id: 'Lavender', acc: '#7C6BD9', deep: '#5F4EC2', tint: '#EDE9FB' },
	{ id: 'Seafoam', acc: '#2E9E93', deep: '#1F7E75', tint: '#DCF1EE' },
	{ id: 'Blush', acc: '#D96A8B', deep: '#BC4E71', tint: '#FBE7ED' }
]
export const N2F_LP_PHOTOS = [
	'https://images.unsplash.com/photo-1611173622933-91942d394b04?q=80&w=900&auto=format&fit=crop',
	'https://images.unsplash.com/photo-1534361960057-19889db9621e?q=80&w=600&auto=format&fit=crop',
	'https://images.unsplash.com/photo-1719464454959-9cf304ef4774?q=80&w=1600&auto=format&fit=crop'
]
function N2fLanding({ on }) {
	const phase = useN2Phases(on, [[1200, 't1'], [2300, 't2'], [3400, 't0'], [4300, 'cursor'], [5200, 'press'], [5700, 'toast']])
	const [pick, setPick] = React.useState(null)
	const P = ['idle', 't1', 't2', 't0', 'cursor', 'press', 'toast']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	const ti = pick != null ? pick : phase === 't1' ? 1 : at('t2') ? 2 : 0
	const th = N2F_LP_THEMES[ti]
	return (
		<div className="n2f-sc1">
			<div className="n2f-sw">
				Make it yours
				{N2F_LP_THEMES.map((t, i) => (
					<i key={t.id} className={i === ti ? 'on' : ''} style={{ background: t.acc }} role="button" tabIndex={0}
						aria-label={'Preview the ' + t.id + ' theme'} title={t.id}
						onClick={() => setPick(i)}
						onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPick(i) } }}></i>
				))}
			</div>
			<N2Sticker blush icon="heart" style={{ left: -18, top: 108, transform: 'rotate(-3deg)', zIndex: 6 }}>No website? This is it.</N2Sticker>
			<N2Window url="namigrooming.nami.pet">
				<div className="n2f-lp" style={{ '--lpa': th.acc, '--lpd': th.deep, '--lpt': th.tint }}>
					<div className="n2f-lp-nav">
						<img src={namiLogo} alt="" />
						<strong>Nami Grooming</strong>
						<span className="n2f-lp-links"><span>About</span><span>Services</span><span>Gallery</span><span>Visit us</span></span>
						<span className="n2f-lp-bk"><N2Paw size={11} />Book now</span>
					</div>
					<div className="n2f-lp-hero">
						<span className="ph"><img src={N2F_LP_PHOTOS[0]} alt="" loading="lazy" /></span>
						<span className="col">
							<span className="ph"><img src={N2F_LP_PHOTOS[1]} alt="" loading="lazy" /></span>
							<span className="ph"><img src={N2F_LP_PHOTOS[2]} alt="" loading="lazy" /></span>
						</span>
					</div>
					<div className="n2f-lp-bar">
						<img src={namiLogo} alt="" />
						<div>
							<h4>Nami Grooming</h4>
							<span className="n2f-lp-meta"><i className="dot"></i><span className="open">Open now</span>· closes 5:00 PM · (443) 681-0681</span>
						</div>
						<span className="n2f-lp-cta">Book an appointment</span>
					</div>
					<div className="n2f-lp-svc">
						<div className="h">Services <em>&amp; pricing</em></div>
						<div className="n2f-lp-cat">
							<div className="n2f-lp-cath"><span className="no">01</span><strong>Full Grooms</strong><span className="from">from $80 · 4 options</span><span className="xx"><N2Ic name="x" size={9} sw={2.4} /></span></div>
							<div className="n2f-lp-it">
								<span className="t"><strong>Full Groom — Small</strong><small>Up to 25 lbs.</small></span>
								<span className="m"><strong>$80</strong><small>50 min</small></span>
								<span className="n2f-lp-book">Book<N2Ic name="arrow" size={10} sw={2.2} /></span>
							</div>
							<div className="n2f-lp-it">
								<span className="t"><strong>Full Groom — Medium</strong><small>25–50 lbs.</small></span>
								<span className="m"><strong>$95</strong><small>60 min</small></span>
								<span className={'n2f-lp-book' + (phase === 'press' ? ' pressed' : '')}>Book<N2Ic name="arrow" size={10} sw={2.2} /><N2Cursor show={phase === 'cursor' || phase === 'press'} press={phase === 'press'} x="30px" y="11px" /></span>
							</div>
						</div>
						<div className="n2f-lp-cat">
							<div className="n2f-lp-cath"><span className="no">02</span><strong>Baths &amp; Tidy</strong><span className="from">from $18 · 3 options</span><span className="xx"><N2Ic name="plus" size={9} sw={2.4} /></span></div>
						</div>
					</div>
				</div>
			</N2Window>
			<div className={'n2f-poptoast' + (at('toast') ? ' show' : '')}>
				<N2Toast ic="mint" icon="globe" title="New request — Waffles" sub="Full Groom — Medium · Sat 10:00 AM" />
			</div>
			<div className="n2f-cap">Booked Tuesday at 9:12 PM — <strong>after close.</strong></div>
		</div>
	)
}

/* ── shared phone frame ── */
export function N2fPhone({ children, name = 'Pawfect Grooming Co.', ava }) {
	return (
		<div className="n2f-ph-wrap">
			<div className="n2f-phone">
				<div className="n2f-ph-scr">
					<div className="n2f-ph-top">
						<span className="ava">{ava || <N2Paw size={13} />}</span>
						<div><strong>{name}</strong><span>Text message</span></div>
					</div>
					<div className="n2f-ph-msgs">{children}</div>
				</div>
			</div>
		</div>
	)
}

/* ── scene 2 · automated reminders ── */
const N2F_RM_SEG = [
	['t', 'Hi '], ['k', 'Client name'], ['t', '! '], ['k', 'Pet name'], ['t', '’s '], ['k', 'Service'],
	['t', ' with '], ['k', 'Groomer'], ['t', ' is tomorrow at '], ['k', 'Time'],
	['t', '. See you soon!']
]
function N2fReminders({ on }) {
	const phase = useN2Phases(on, [[3000, 'sms'], [4400, 'typing'], [5400, 'reply']])
	const P = ['idle', 'sms', 'typing', 'reply']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	return (
		<React.Fragment>
			<div className="n2f-sc2">
				<div className="n2f-rm">
					<div className="n2f-rm-head"><span className="t">Reminders</span><span className="pill"><N2Ic name="check" size={11} sw={2.8} />3 of 3 on</span></div>
					<div className="n2f-rm-tl" aria-hidden="true">
						<span className="tn"><i>3</i>1 week before</span>
						<span className="tn live"><i>2</i>1 day before</span>
						<span className="tn"><i>1</i>2 hours before</span>
						<span className="tn"><i><NIc name="calendar" size={12} sw={1.8} /></i>Appointment</span>
					</div>
					<div className="n2f-rm-card">
						<div className="n2f-rm-rh">
							<span className="num">2</span>
							<div><strong>Second reminder</strong><span>A heads-up the day before</span></div>
							<span className="n2f-tog" aria-hidden="true"><i></i></span>
						</div>
						<div className="n2f-lbl">When to send</div>
						<div className="n2f-whens"><span>12 hours before</span><span className="on">1 day before</span><span>2 days before</span></div>
						<div className="n2f-lbl">Message</div>
						<div className={'n2f-rm-msg' + (on ? ' go' : '')}>
							{N2F_RM_SEG.map(([k, v], i) => k === 't'
								? <span className="seg" key={i} style={{ '--i': i }}>{v}</span>
								: <span className="seg n2f-tok" key={i} style={{ '--i': i }}>{v}</span>)}
						</div>
						<div className="n2f-ins"><em>Insert</em><span>Pet name</span><span>Client name</span><span>Date</span><span>Time</span><span>Groomer</span><span>Service</span></div>
					</div>
				</div>
				<N2fPhone name="Harper Quinn" ava="HQ">
					<div className={'n2f-bub out' + (at('sms') ? ' show' : '')}>Hi Harper! Waffles’ Full Groom with Ashley is tomorrow at 10:00 AM. See you soon!</div>
					{phase === 'typing' ? <span className="n2f-typing" aria-hidden="true"><i></i><i></i><i></i></span> : null}
					<div className={'n2f-bub' + (at('reply') ? ' show' : '')}>Thanks! See you tomorrow!</div>
				</N2fPhone>
			</div>
			<div className="n2f-cap">You write it once. Nami sends it before <strong>every visit, forever.</strong></div>
		</React.Fragment>
	)
}

/* ── scene 3 · digital agreements ── */
const N2F_AG_ITEMS = ['Service Agreement', 'Vaccination Agreement', 'Matted Release Form', 'Pet Health & Behavior Disclosure']
export function N2fAgreements({ on }) {
	const phase = useN2Phases(on, [[700, 'cursor'], [1400, 'tick1'], [2200, 'tick2'], [3000, 'press'], [3600, 'sms'], [4500, 'sheet'], [4900, 'sign'], [6900, 'stored']])
	const P = ['idle', 'cursor', 'tick1', 'tick2', 'press', 'sms', 'sheet', 'sign', 'stored']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	const cursorOn = ['cursor', 'tick1', 'tick2', 'press'].includes(phase)
	const cxy = phase === 'cursor' || phase === 'tick1' ? ['26px', '52px'] : phase === 'tick2' ? ['26px', '90px'] : ['50%', '224px']
	const picked = (at('tick1') ? 1 : 0) + (at('tick2') ? 1 : 0)
	return (
		<React.Fragment>
			<div className="n2f-sc3">
				<div className="n2f-ag">
					<div className="n2f-ag-client">
						<span className="ava">HQ</span>
						<div className="n2f-ag-who">
							<div className="row"><strong>Harper Quinn</strong><span className="n2f-ag-flag"><N2Ic name="spark" size={10} sw={2.2} />New client</span></div>
							<span className="sub">Waffles — Goldendoodle · first visit Sat 10:00 AM</span>
						</div>
						<span className="n2f-ag-btn"><N2Ic name="send" size={13} sw={2} />Send agreements</span>
					</div>
					<div className="n2f-ag-pop">
						<div className="agt">Select agreements</div>
						{N2F_AG_ITEMS.map((a, i) => {
							const onIt = (i === 0 && at('tick1')) || (i === 1 && at('tick2'))
							return (
								<div className={'n2f-agi' + (onIt ? ' on' : '')} key={a}>
									<span className="box">{onIt ? <NIc name="tick" size={11} sw={2.6} /> : null}</span>{a}
								</div>
							)
						})}
						<div className={'n2f-agsend' + (picked ? ' ok' : '') + (phase === 'press' ? ' pressed' : '')}>
							<N2Ic name="send" size={13} sw={2} />{'Send' + (picked ? ' ' + picked : '') + ' agreement' + (picked === 1 ? '' : 's')}
						</div>
						<N2Cursor show={cursorOn} press={phase === 'tick1' || phase === 'tick2' || phase === 'press'} x={cxy[0]} y={cxy[1]} />
					</div>
				</div>
				<N2fPhone>
					<div className={'n2f-bub' + (at('sms') ? ' show' : '')}>Hi Harper! Before Waffles’ first visit Saturday, please review &amp; sign 2 quick forms: <span className="lnk">nami.pet/s/8kF2</span></div>
					<div className={'n2f-sheet' + (at('sheet') ? ' show' : '')}>
						<div className="sh-t"><NIc name="agreements" size={13} sw={1.7} />Service Agreement<span className="of">Nami Grooming · 1 of 2</span></div>
						<div className="sh-lines" aria-hidden="true"><i></i><i></i><i></i></div>
						<div className={'n2f-pad' + (at('sign') ? ' draw' : '')}>
							<svg viewBox="0 0 190 54" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
								<path pathLength="1" d="M10 40 C 16 12 26 10 28 24 C 30 36 24 44 18 45 C 30 44 36 30 44 28 C 40 38 44 43 52 37 C 58 32 60 26 58 24 C 55 29 57 40 66 36 C 74 33 78 23 76 21 C 72 26 74 38 84 34 C 92 31 96 22 102 24 C 108 26 104 41 114 36 C 121 32 124 22 130 26 C 136 30 134 40 144 34 C 152 29 158 22 166 28 C 172 32 178 26 183 21"></path>
							</svg>
							<span className="base" aria-hidden="true"></span>
						</div>
						<div className={'n2f-shbtn' + (at('stored') ? ' done' : '')}>
							{at('stored') ? <React.Fragment><N2Ic name="check" size={12} sw={2.8} />Signed</React.Fragment> : 'Agree & sign'}
						</div>
					</div>
					<div className={'n2f-conf' + (at('stored') ? ' show' : '')}><N2Ic name="check" size={12} sw={2.8} />2 of 2 signed — stored on Waffles’ profile</div>
				</N2fPhone>
			</div>
			<div className="n2f-cap">Two taps for them. <strong>Proof for you.</strong></div>
		</React.Fragment>
	)
}

/* ── scene 4 · Square checkout — the real Log Payment panel + terminal, phase-driven ── */
function N2fMoney({ to }) {
	const reduce = React.useRef(window.matchMedia('(prefers-reduced-motion: reduce)').matches).current
	const [v, setV] = React.useState(to)
	const prev = React.useRef(to)
	React.useEffect(() => {
		const from = prev.current
		prev.current = to
		if (reduce || from === to) { setV(to); return }
		let raf, t0
		const tick = (t) => {
			if (!t0) t0 = t
			const p = Math.min(1, (t - t0) / 550), e = 1 - Math.pow(1 - p, 3)
			setV(from + (to - from) * e)
			if (p < 1) raf = requestAnimationFrame(tick)
		}
		raf = requestAnimationFrame(tick)
		return () => cancelAnimationFrame(raf)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [to])
	return <span>${v.toFixed(2)}</span>
}
const N2FK_TIPS = [['15%', '$18.00'], ['18%', '$21.60'], ['25%', '$30.00'], ['Custom', '% or $']]
export function N2fCheckout({ on }) {
	const phase = useN2Phases(on, [[800, 'cursor'], [1700, 'tip'], [2800, 'cursor2'], [3600, 'charge'], [5100, 'paid'], [6100, 'toast']])
	const P = ['idle', 'cursor', 'tip', 'cursor2', 'charge', 'paid', 'toast']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	const tipped = at('tip')
	const total = tipped ? 145.08 : 123.48
	return (
		<React.Fragment>
			<div className="n2f-sc4">
				<div className="n2fk">
					<div className="n2fk-head">
						<div>
							<h5>Log Payment</h5>
							<span className="sub">Waffles — Goldendoodle · Sat 10:00 AM</span>
						</div>
						<span className="n2fk-done"><N2Ic name="check" size={10} sw={3} />Groom finished</span>
					</div>
					<div className="n2fk-sect">Service</div>
					<div className="n2fk-line"><span>Full Groom — Medium<span className="pet">Waffles · with Ashley</span></span><strong>$95.00</strong></div>
					<div className="n2fk-sect">Add-ons</div>
					<div className="n2fk-line sm"><span>De-shedding Treatment</span><strong>$25.00</strong></div>
					<div className="n2fk-sect">Tip for Ashley</div>
					<div className="n2fk-chips">
						{N2FK_TIPS.map(([t, b], i) => (
							<span className={'n2fk-chip' + (i === 1 && tipped ? ' on' : '')} key={t}>
								<span className="t">{t}</span><span className="b">{b}</span>
								{i === 1 ? <N2Cursor show={phase === 'cursor' || phase === 'tip'} press={phase === 'tip'} x="16px" y="18px" /> : null}
							</span>
						))}
					</div>
					<div className="n2fk-sect">Payment method</div>
					<div className="n2fk-tiles">
						<span className="n2fk-tile"><N2Ic name="card" size={14} sw={1.9} />Card</span>
						<span className="n2fk-tile"><N2Ic name="tap" size={14} sw={1.9} />Apple Pay</span>
						<span className="n2fk-tile on"><N2Ic name="phone" size={14} sw={1.9} />Sq. Terminal</span>
					</div>
					<div className="n2fk-sum">
						<div className="n2fk-row"><span>Subtotal</span><span>$120.00</span></div>
						<div className="n2fk-row"><span>Tax (2.9%)</span><span>$3.48</span></div>
						<div className={'n2fk-row tip' + (tipped ? ' show' : '')}><span>Tip (18%)</span><span>$21.60</span></div>
						<div className="n2fk-row total"><span>Total</span><strong><N2fMoney to={total} /></strong></div>
					</div>
					<div className={'n2fk-charge' + (phase === 'charge' ? ' pressed' : '') + (at('charge') ? ' sent' : '')}>
						<N2Ic name="tap" size={15} sw={1.9} />{at('charge') ? 'Sent to Square Terminal' : 'Complete payment'} · <N2fMoney to={total} />
						<N2Cursor show={phase === 'cursor2' || phase === 'charge'} press={phase === 'charge'} x="58%" y="12px" />
					</div>
				</div>
				<div className="n2fk-side">
					<N2Sticker blush icon="heart" style={{ position: 'static' }}>Tips prompted — no awkward ask</N2Sticker>
					<div className={'n2fk-term' + (at('charge') ? ' live' : '') + (at('paid') ? ' paid' : '')} aria-hidden="true">
						<div className="n2fk-face">
							<span className="n2fk-brand">Square Terminal</span>
							<span className="n2fk-amt">{at('charge') ? '$145.08' : '· · ·'}</span>
							<span className="n2fk-tap"><N2Ic name="tap" size={16} sw={1.8} />Tap, dip, or swipe</span>
							<span className="n2fk-paid">
								<N2Ic name="check" size={15} sw={2.6} />Paid — receipt texted
								<span className="n2fk-pop" aria-hidden="true">
									<i style={{ '--dx': '-26px', '--dy': '-30px', background: '#DD66A6' }}></i>
									<i style={{ '--dx': '18px', '--dy': '-36px', background: '#7C6BD9' }}></i>
									<i style={{ '--dx': '38px', '--dy': '-16px', background: '#5B79E3' }}></i>
									<i style={{ '--dx': '-38px', '--dy': '-8px', background: '#2F8A5B' }}></i>
									<i style={{ '--dx': '30px', '--dy': '8px', background: '#C08A2D' }}></i>
									<i style={{ '--dx': '-16px', '--dy': '14px', background: '#7C6BD9' }}></i>
								</span>
							</span>
							<i className="n2fk-ring"></i><i className="n2fk-ring r2"></i>
						</div>
					</div>
					<div className={'n2fk-rise' + (at('toast') ? ' show' : '')}>
						<N2Toast ic="mint" icon="receipt" title="Waffles paid · $145.08" sub="Square · one clean deposit" />
					</div>
					<span className={'n2fk-rebook n2fk-rise' + (at('toast') ? ' show' : '')}><N2Ic name="repeat" size={13} sw={2.2} />Rebook nudge scheduled — 6 weeks out</span>
				</div>
			</div>
			<div className="n2f-cap">Ten seconds at the counter — <strong>the receipt texts itself.</strong></div>
		</React.Fragment>
	)
}

/* ── the act ── */
const N2F_STEPS = [
	{ id: 'landing', kick: '01 · Booked', crumb: 'Booked',
		h: <React.Fragment>Your <em>landing page</em></React.Fragment>,
		sub: 'Never lose a booking with 24/7 reception.',
		p: 'Launch a personalized business page, up and running in seconds. Clients book 24/7. You approve on your time.',
		checks: ['Services & pricing, photo gallery, reviews, socials — all on one page', 'Requests land straight in your Bookings inbox', 'Your brand, your way — colors, themes & layout, styled in clicks'],
		fact: 'Tue 9:12 PM — Harper books Waffles’ first groom',
		cta: 'Claim your booking page',
		scene: (on) => <N2fLanding on={on} /> },
	{ id: 'reminders', kick: '02 · Reminded', crumb: 'Reminded',
		h: <React.Fragment>Automated <em>reminders</em></React.Fragment>,
		sub: '85% fewer no-shows. Zero phone calls.',
		p: 'No-shows cost you money. Nami sends up to three reminders before every visit, by text and email, filled in from the booking. You never write one again.',
		checks: ['85% fewer no-shows', 'A week, days, or hours before. You choose.', 'Zero manual work. Every detail pulls from the booking.'],
		fact: 'Fri 10:00 AM — reminder out · no-show prevented · no calls made',
		cta: 'Put reminders on autopilot',
		scene: (on) => <N2fReminders on={on} /> },
	{ id: 'agreements', kick: '03 · Signed', crumb: 'Signed',
		h: <React.Fragment>Digital <em>agreements</em></React.Fragment>,
		sub: 'Signed before drop-off. Proof when it matters.',
		p: 'A shaved-down matted coat. A nick. A client who says they never agreed. Nami gets every waiver signed by text before the appointment and keeps it on the pet’s profile.',
		checks: ['Matted release, vaccination, service, health & behavior forms built in', 'Clients sign on their phone in under a minute', 'Every signature saved to the pet, ready when you need it'],
		fact: 'Sat 8:41 AM — both forms signed before drop-off',
		cta: 'Get waivers signed for you',
		scene: (on) => <N2fAgreements on={on} /> },
	{ id: 'square', kick: '04 · Paid', crumb: 'Paid',
		h: <React.Fragment>Checkout, <em>Square built in</em></React.Fragment>,
		sub: 'Goodbye takes ten seconds.',
		p: 'The screen prompts the tip so you don’t have to. Tax and add-ons total themselves, the card runs, and the receipt texts before they reach the car.',
		checks: ['Already on Square? Keep it. Nami runs on your account and terminal.', 'Card, Apple Pay, or terminal. Clients pay however they want.', 'Every payment logged to the pet. Nothing to reconcile tonight.'],
		fact: 'Sat 11:04 AM — $145.08 collected · tipped · receipted',
		cta: 'Keep your Square, add Nami',
		scene: (on) => <N2fCheckout on={on} /> }
]

export function N2Features() {
	const [act, setAct] = React.useState(0)
	const refs = React.useRef([])
	React.useEffect(() => {
		let raf = 0
		const calc = () => {
			raf = 0
			const line = window.innerHeight * 0.55
			let a = 0
			refs.current.forEach((el, i) => { if (el && el.getBoundingClientRect().top < line) a = i })
			setAct((c) => (c === a ? c : a))
		}
		const onTrigger = () => { if (!raf) raf = requestAnimationFrame(calc) }
		calc()
		// Capture phase: the app scrolls on <body>, not the window (see index.css).
		window.addEventListener('scroll', onTrigger, { capture: true, passive: true })
		window.addEventListener('resize', onTrigger)
		// Safety net: an IntersectionObserver with dense thresholds re-runs the same
		// calculation as the steps move through the viewport, so the active section
		// keeps tracking even if a scroll event is missed or deferred.
		const io = new IntersectionObserver(onTrigger, { threshold: Array.from({ length: 21 }, (_, i) => i / 20) })
		const observed = refs.current.filter(Boolean)
		observed.forEach((el) => io.observe(el))
		return () => {
			window.removeEventListener('scroll', onTrigger, { capture: true })
			window.removeEventListener('resize', onTrigger)
			io.disconnect()
			if (raf) cancelAnimationFrame(raf)
		}
	}, [])
	return (
		<section className={'n2f' + (act === 3 ? ' is-dark' : '')} id="features" data-act={act}>
			<div className="n2f-shore" aria-hidden="true">
				<svg viewBox="0 0 1440 230" preserveAspectRatio="none">
					<defs>
						<linearGradient id="n2fsea" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0" stopColor="#7C6BD9" stopOpacity="0"></stop>
							<stop offset="0.6" stopColor="#7C6BD9" stopOpacity="0.13"></stop>
							<stop offset="1" stopColor="#8B7DDE" stopOpacity="0.19"></stop>
						</linearGradient>
						<linearGradient id="n2fsea2" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0" stopColor="#8B7DDE" stopOpacity="0"></stop>
							<stop offset="1" stopColor="#8B7DDE" stopOpacity="0.075"></stop>
						</linearGradient>
						<filter id="n2ffoam" x="-20%" y="-300%" width="140%" height="700%"><feGaussianBlur stdDeviation="1.4"></feGaussianBlur></filter>
					</defs>
					<g className="n2f-w2">
						<path d="M0 -80 L0 152 q 84 7 172 4 q 80 -9 168 -5 q 78 8 164 5 q 82 -10 170 -4 q 76 7 162 4 q 80 -8 172 -5 q 90 6 216 3 q 86 -7 216 -4 L1440 -80 Z" fill="url(#n2fsea2)"></path>
						<path d="M0 152 q 84 7 172 4 q 80 -9 168 -5 q 78 8 164 5 q 82 -10 170 -4 q 76 7 162 4 q 80 -8 172 -5 q 90 6 216 3 q 86 -7 216 -4" fill="none" stroke="#FFFFFF" strokeWidth="1.4" opacity="0.5" vectorEffect="non-scaling-stroke"></path>
					</g>
					<g className="n2f-w1">
						<path d="M0 -80 L0 96 q 70 9 148 5 q 66 -11 142 -7 q 62 12 138 8 q 74 -13 150 -5 q 60 9 132 3 q 70 -10 146 -7 q 64 11 140 9 q 66 -12 142 -6 q 60 8 152 5 q 62 -8 150 -4 L1440 -80 Z" fill="url(#n2fsea)"></path>
						<path transform="translate(0,-8)" d="M0 96 q 70 9 148 5 q 66 -11 142 -7 q 62 12 138 8 q 74 -13 150 -5 q 60 9 132 3 q 70 -10 146 -7 q 64 11 140 9 q 66 -12 142 -6 q 60 8 152 5 q 62 -8 150 -4" fill="none" stroke="#FFFFFF" strokeWidth="1.2" strokeDasharray="16 10 5 14 26 8 9 18" opacity="0.34" vectorEffect="non-scaling-stroke"></path>
						<path className="n2f-foamwide" d="M0 96 q 70 9 148 5 q 66 -11 142 -7 q 62 12 138 8 q 74 -13 150 -5 q 60 9 132 3 q 70 -10 146 -7 q 64 11 140 9 q 66 -12 142 -6 q 60 8 152 5 q 62 -8 150 -4" fill="none" stroke="#FFFFFF" strokeWidth="4.5" opacity="0.4" filter="url(#n2ffoam)" vectorEffect="non-scaling-stroke"></path>
						<path d="M0 96 q 70 9 148 5 q 66 -11 142 -7 q 62 12 138 8 q 74 -13 150 -5 q 60 9 132 3 q 70 -10 146 -7 q 64 11 140 9 q 66 -12 142 -6 q 60 8 152 5 q 62 -8 150 -4" fill="none" stroke="#FFFFFF" strokeWidth="1.8" opacity="0.92" vectorEffect="non-scaling-stroke"></path>
					</g>
				</svg>
				{/* paw trail padding left→right along the sand; each print fades in on its turn, lingers, fades; the cycle restarts from the left */}
				<div className="n2f-sandtrail">
					{Array.from({ length: 16 }, (_, i) => (
						<span key={i} style={{ '--i': i, left: (3 + i * 6) + '%', bottom: (i % 2 ? 30 : 18) + 'px', transform: 'rotate(' + (i % 2 ? 98 : 82) + 'deg)' }}><N2Paw size={13} /></span>
					))}
				</div>
			</div>
			<div className="n2f-washes" aria-hidden="true"><i className="w0"></i><i className="w1"></i><i className="w2"></i><i className="w3"></i></div>
			<span className="n2f-darkpaw" style={{ top: -60, left: -40, transform: 'rotate(-18deg)' }} aria-hidden="true"><N2Paw size={340} /></span>
			<span className="n2f-darkpaw" style={{ bottom: -90, right: -50, transform: 'rotate(14deg)' }} aria-hidden="true"><N2Paw size={420} /></span>
			<div className="n2f-head n2-wrap">
				<N2SectionHead eyebrow="Follow one visit" title={<React.Fragment>Watch a visit run <em>itself.</em></React.Fragment>}
					sub="Follow Waffles the Goldendoodle through one visit. Booked, reminded, signed, and paid. Nami handles all of it, so you don't have to." />
			</div>
			<div className="n2f-body n2-wrap">
				<div className="n2f-steps">
					{N2F_STEPS.map((s, i) => (
						<article className={'n2f-step' + (act === i ? ' live' : act > i ? ' past' : '')} key={s.id} id={s.id === 'square' ? 'square' : undefined}
							data-i={i} ref={(el) => { refs.current[i] = el }}>
							<span className="n2f-kick"><N2Paw size={12} />{s.kick}</span>
							<h3>{s.h}</h3>
							<p className="n2f-sub">{s.sub}</p>
							<p>{s.p}</p>
							<ul className="n2f-checks">{s.checks.map((c) => <li key={c}><N2Ic name="check" size={14} sw={2.5} />{c}</li>)}</ul>
							<span className="n2f-fact"><N2Ic name="clock" size={13} sw={2.1} />{s.fact}</span>
							{s.cta ? <N2Btn to="/login" small onClick={trackGetStartedClick('feature_' + s.id, s.cta)}>{s.cta}</N2Btn> : null}
						</article>
					))}
				</div>
				<div className="n2f-stagecol">
					<div className="n2f-sticky">
						<div className="n2f-stages">
							{N2F_STEPS.map((s, i) => (
								<div key={s.id} className={'n2f-stage' + (act === i ? ' on' : i < act ? ' before' : ' after')} aria-hidden={act !== i}>
									{s.scene(act === i)}
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
			<N2Scallop fill="#FFFFFF" />
		</section>
	)
}
